import { volcanicAshId } from "../constants/themeIds";

const volcanicAsh = {
  themeId: volcanicAshId,
  author: "ImACoderImACoderImACoder",
  borderStyle: "solid",
  borderColor: "#FF6600",
  buttonColorMain: "#242526",
  currentTemperatureColor: "#FF6600",
  targetTemperatureColor: "white",
  buttonActive: {
    color: "white",
    backgroundColor: "#FF6600",
    borderColor: "white",
  },
  backgroundColor: "black",
  primaryFontColor: "white",
  iconColor: "#FF6600",
  iconTextColor: "white",
  plusMinusButtons: {
    backgroundColor: "#242526",
    color: "white",
    borderColor: "FF6600",
  },
  workflowEditor: {
    accordianExpandedColor: "#FF6600",
  },
  temperatureRange: {
    lowTemperatureColor: "#f53803",
    highTemperatureColor: "#f5d020",
    background: "linear-gradient(315deg, #f53803 0%, #f5d020 74%)",
    rangeBoxColor: "black",
    rangeBoxBorderColor: "orange",
  },
  ToggleButtons: {
    sliderBackgroundColorOn: "#FF6600",
    sliderBackgroundColorOff: "#242526",
    sliderBorderColorOn: "#f8f9fa",
    onBackgroundColor: "#FF6600",
    onBorderColor: "white",
    onColor: "#fff",
    offBackgroundColor: "#242526",
    offBorderColor: "#FF6600",
    offColor: "#fff",
  },
};

export default volcanicAsh;
